const GIL_RISK_ERROR_CODE = 'gil_risk_error',
  GIL_OTP_ERROR_CODE = 'gil_otp_limit_error';

export { GIL_RISK_ERROR_CODE, GIL_OTP_ERROR_CODE };
